export const environment = {
  production: true,
  // URL of production API
  API_HOST: 'https://api.staging.expressyon.com',
  APP_VERSION: '3.1.52',
};
